module.exports = __webpack_public_path__ + "static/img/Aac2.47b010a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Aac2.png
// module id = 3+8s
// module chunks = 1